import { useMutation } from '@tanstack/react-query';
import supabaseClient from '@/api/supabaseClient';
import invokeRefinement from '@/api/itineraries/invokeRefinement.ts';
import { queryClient } from '@/main.tsx';
import type { UndoItineraryChangePayload } from '$/requests/UndoItineraryChangeRequest.ts';

const useUndoItineraryChange = () =>
  useMutation({
    mutationFn: (request: UndoItineraryChangePayload) =>
      invokeRefinement(supabaseClient, 'undo_itinerary_change', request),
    retry: false,
    onSuccess: (result) => {
      if (result.outcome !== 'changed') return;

      void queryClient.invalidateQueries({ queryKey: ['itineraries'] });
      void queryClient.invalidateQueries({ queryKey: ['places'] });
    },
  });

export default useUndoItineraryChange;
